import React, { useState } from "react";
import { Button, Space, Switch, Table, TableProps } from "antd";
import type { TableColumnsType } from "antd";
import { useNavigate } from "react-router-dom";
import { cardData } from "../scripts/products";
import { fabrics } from "../scripts/fabrics";
import ContactModal from "../components/modals/contactModal";

interface DataType {
  key: React.ReactNode;
  name: string;
  price: number | string;
  seller?: any;
  unit: number;
  phone?: string;
  children?: DataType[];
}
type TableRowSelection<T extends object = object> =
  TableProps<T>["rowSelection"];

const data: DataType[] = [
  {
    key: 1,
    name: "Вода",
    price: "32(ср.)",
    unit: 100,
    children: [
      {
        key: 11,
        name: 'Вода "Поречская"',
        price: 40,
        unit: 60,
        seller: "2",
        phone: "89111",
      },
      {
        key: 12,
        name: 'Вода "Родничок" артезианская негазированная бутилированная',
        price: 20,
        unit: 40,
        seller: "0",
        phone: "89212",
      },
    ],
  },
  {
    key: 2,
    name: 'Вода "Минеральная" артезианская негазированная бутилированная',
    price: 80,
    unit: 100,
    seller: "5",
    phone: "89566",
  },
];

// rowSelection objects indicates the need for row selection
const rowSelection: TableRowSelection<DataType> = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(
      `selectedRowKeys: ${selectedRowKeys}`,
      "selectedRows: ",
      selectedRows
    );
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows);
  },
};

const Search: React.FC = () => {
  const [checkStrictly, setCheckStrictly] = useState(false);
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  const columns: TableColumnsType<DataType> = [
    {
      title: "Продавец",
      dataIndex: "seller",
      key: "seller",
      render: (seller) => (
        <>
          {seller ? (
            <a onClick={() => navigate(`/factory/${seller}`)}>
              {fabrics[seller]?.title}
            </a>
          ) : (
            "Cборный заказ"
          )}
        </>
      ),
    },
    { title: "Название", dataIndex: "name", key: "name" },
    { title: "Номер", dataIndex: "key", key: "key" },
    { title: "Цена (без учета доставки)", dataIndex: "price", key: "price" },
    { title: "Единиц товара", dataIndex: "unit", key: "unit" },
    {
      title: "Контакты",
      dataIndex: "phone",
      key: "phone",
      render: (phone) => (
        <>
          {phone && (
            <Button onClick={() => setModalOpen(true)}>Связаться</Button>
          )}
        </>
      ),
    },
  ];

  return (
    <div className="App">
      <h2>Результаты поиска</h2>
      <div className="white-back">
        <Table<DataType>
          columns={columns}
          //rowSelection={{ ...rowSelection, checkStrictly }}
          dataSource={data}
        />
      </div>
      <ContactModal open={modalOpen} isCloseModal={closeModal} />
    </div>
  );
};

export default Search;
